var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 0H11.6667V3.80952H23.3333V0ZM15.5556 24.7619H19.4444V13.3333H15.5556V24.7619ZM31.1694 12.1714L33.9306 9.46667C33.0944 8.49524 32.1806 7.58095 31.1889 6.78095L28.4278 9.48571C25.4139 7.12381 21.6222 5.71429 17.5 5.71429C7.83611 5.71429 0 13.3905 0 22.8571C0 32.3238 7.81667 40 17.5 40C27.1833 40 35 32.3238 35 22.8571C35 18.819 33.5611 15.1048 31.1694 12.1714ZM17.5 36.1905C9.975 36.1905 3.88889 30.2286 3.88889 22.8571C3.88889 15.4857 9.975 9.52381 17.5 9.52381C25.025 9.52381 31.1111 15.4857 31.1111 22.8571C31.1111 30.2286 25.025 36.1905 17.5 36.1905Z",
    fill: "#7A53FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/Timer.6f578b42b7360d3add17885d01432eaa.svg";
export { ForwardRef as ReactComponent };